<div class="cardLayout">
  <ion-row>
    <ion-col size="12">
      <div class="popup-heading">
        <div>
          <p class="fs-16 font_regular">Add Letter</p>
         </div>
         <div class="popup-close">
          <span class="ml-35 mr-5 fs-30 material-icons popup-close-icon" (click)="onClickClosePopup()">close</span>
        </div>
      </div>
 
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size-sm="6" size-md="7" size-lg="7" size-xs="6">
      <ion-row class="display-space-between">
        <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
          <p class="fs-16 font_semibold" >Letter Name:</p>
        </ion-col>
        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40  mat-input-style">
            <input matInput [(ngModel)]="addlLetterName" placeholder="Type here" (ngModelChange)="isValicIncrementLetter()">
          </mat-form-field>
          <div *ngIf="isInValidlLetterName" class="fs-14 red mt-5">Enter Letter Name</div>
          <div *ngIf="errorMessage" class="fs-14 red mt-5">
            This letter name already exists. Please enter a different letter name.
          </div>
        </ion-col>
      </ion-row>
    </ion-col>
    <ion-col size-sm="6" size-md="5" size-lg="5" size-xs="6">
      <div class="btn-Group">
        <button class="saveBtn" (click)="onClickSaveBtn()" [disabled]="isDisabledIncrementLetter"
        [ngClass]="{ 'disable': isDisabledIncrementLetter }">Save</button>
        <button class="mr-20 DiscardChangesBtn" (click)="onClickDiscardChanges()">Discard Changes</button>
      </div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size-sm="6" size-md="7" size-lg="7" size-xs="6">
      <ion-row class="display-space-between">
        <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
          <p class="fs-16 font_semibold" >Subject:</p>
        </ion-col>
        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class=" w-100 mat-height40  mat-input-style">
            <input matInput [(ngModel)]="addEmailSubject" placeholder="Type here" (ngModelChange)="isValicIncrementLetter()">
          </mat-form-field>
          <div *ngIf="isInValidLetterSubject" class="fs-14 red mt-5">Enter Letter Subject</div>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
<ion-row>
  <ion-col>
    <angular-editor [placeholder]="'Enter Email here...'" [config]="editorConfig"
    [(ngModel)]="AddLetterContent" (ngModelChange)="isValicIncrementLetter()" (click)="onClickRemoveLetterSubject()"></angular-editor>
    <div *ngIf="isInvalidLetterBody" class="fs-14 red mt-5">Enter Letter Email</div>
  </ion-col>
</ion-row>
</div>

